/**
 * Product Detail Vue Component
 * ------------------------------------------------------------------------------
 * Main template in sections/product__main.liquid
 */

import { Splide, SplideSlide } from '@splidejs/vue-splide'
import { getUrlWithVariant } from '@shopify/theme-product-form'

import ImageZoom from './image-zoom.vue'
import ReadMore from './read-more.vue'
import VueAccordion from './vue-accordion.vue'
import VueCollapsible from './vue-collapsible.vue'
import { product } from '../mixins/product.js'

import { removeParameterFromUrl } from '../utils/helpers.js'

export default {
  components: {
    Splide,
    SplideSlide,
    ImageZoom,
    ReadMore,
    VueAccordion,
    VueCollapsible
  },

  mixins: [
    product
  ],

  data () {
    return {
      currentSlide: 0,
      mainSplideOptions: {
        type: 'loop',
        perPage: 1,
        pagination: false
      },
      navSplideOptions: {
        type: 'slide',
        rewind: true,
        gap: '4px',
        pagination: false,
        fixedWidth: 110,
        fixedHeight: 110,
        cover: true,
        focus: 'center',
        isNavigation: true,
        updateOnMove: true
      }
    }
  },

  mounted () {
    const mainSplide = this.$refs.main
    const navSplide = this.$refs.nav

    if (mainSplide && navSplide) {
      mainSplide.sync(navSplide.splide)
    }

    // if the URL has variant query string, select that variant
    const queryStringValues = new URLSearchParams(window.location.search)
    if (queryStringValues.has('variant')) {
      this.currentVariant = this.product.variants.find(variant => `${variant.id}` === queryStringValues.get('variant'))
    } else if (this.product.variants.length === 1) {
      this.currentVariant = this.product.variants[0]
    }

    this.$nextTick(() => {
      this._initSelectedOptions()
    })
  },

  methods: {
    handleSplideMoved (newIndex) {
      this.currentSlide = newIndex
    },

    // Overrides mixin's method
    _selectVariant (variant) {
      this.currentVariant = variant || null

      if (!variant) {
        removeParameterFromUrl('variant')
        return
      }

      if (variant.featured_image && this.product.images.length > 1) {
        this.$refs.main.go(variant.featured_image.position - 1)
      }

      const url = getUrlWithVariant(window.location.href, variant.id)
      window.history.replaceState({ path: url }, '', url)
    }
  }
}
